// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.large_product_card_container__PNciR {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    max-width: 500px;
    border: 1px solid #ddd;
    margin: 0 10px;
    padding: 0 5px;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    background-color: #FFFFFF;
    min-height: 130px;
}

.large_product_card_addButton__TqIdE {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    width: 30px;
    position: absolute;
    right: 15px;
    border-radius: 50%;
    border: #46b38c 2px solid;
    top: 5px;
    font-weight: 600;
    background-color: #FFFFFF;
    color: #46b38c;
    transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out;
    -webkit-user-select: none;
            user-select: none;
    cursor: pointer;
}

.large_product_card_addButton__TqIdE > div {
    margin: 0;
    padding: 0;
}

.large_product_card_addButton__TqIdE:hover {
    background-color: #46b38c;
    color: #FFFFFF;
}

.large_product_card_quantityButtons__Xtm4X {
    position: absolute;
    background-color: #46b38c;
    color: #FFFFFF;
    display: flex;
    justify-content: space-between;
    width: 120px;
    align-items: center;
    border-radius: 6px;
    font-weight: 600;
    font-size: 1.2rem;
    top: 5px;
    right: 15px;
    -webkit-user-select: none;
            user-select: none;
    cursor: default;
}

.large_product_card_quantityPlusMinus__\\+PmDx {
    cursor: pointer;
    flex-basis: 40%;
}

.large_product_card_productImage__U0iJQ {
    max-width: 120px;
    height: auto;
    max-height: 120px;
    border-radius: 30px;
    border: 3px #fff solid;
    box-shadow: 0 0 1px #000;
}

.large_product_card_productInfo__YLKmj {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: left;
    margin: 4px 4px 4px 0;
    height: 100%;
}

.large_product_card_productPrice__PWsMp {
    font-weight: bold;
}

.large_product_card_productName__jeZdA {
    font-weight: 500;
    margin-top: 5px;
    font-size: 1.2rem;
}

@media (max-width: 650px) {
    .large_product_card_addButton__TqIdE {
        right: 5px !important;
    }

    .large_product_card_quantityButtons__Xtm4X {
        right: 5px !important;
    }

    .large_product_card_container__PNciR {
        margin: 0 !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/shop/components/large_product_card/large_product_card.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wCAAwC;IACxC,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,QAAQ;IACR,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,qEAAqE;IACrE,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,QAAQ;IACR,WAAW;IACX,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,oBAAoB;IACxB;AACJ","sourcesContent":[".container {\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    max-width: 500px;\n    border: 1px solid #ddd;\n    margin: 0 10px;\n    padding: 0 5px;\n    border-radius: 5px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    cursor: pointer;\n    user-select: none;\n    background-color: #FFFFFF;\n    min-height: 130px;\n}\n\n.addButton {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 30px;\n    width: 30px;\n    position: absolute;\n    right: 15px;\n    border-radius: 50%;\n    border: #46b38c 2px solid;\n    top: 5px;\n    font-weight: 600;\n    background-color: #FFFFFF;\n    color: #46b38c;\n    transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out;\n    user-select: none;\n    cursor: pointer;\n}\n\n.addButton > div {\n    margin: 0;\n    padding: 0;\n}\n\n.addButton:hover {\n    background-color: #46b38c;\n    color: #FFFFFF;\n}\n\n.quantityButtons {\n    position: absolute;\n    background-color: #46b38c;\n    color: #FFFFFF;\n    display: flex;\n    justify-content: space-between;\n    width: 120px;\n    align-items: center;\n    border-radius: 6px;\n    font-weight: 600;\n    font-size: 1.2rem;\n    top: 5px;\n    right: 15px;\n    user-select: none;\n    cursor: default;\n}\n\n.quantityPlusMinus {\n    cursor: pointer;\n    flex-basis: 40%;\n}\n\n.productImage {\n    max-width: 120px;\n    height: auto;\n    max-height: 120px;\n    border-radius: 30px;\n    border: 3px #fff solid;\n    box-shadow: 0 0 1px #000;\n}\n\n.productInfo {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    text-align: left;\n    margin: 4px 4px 4px 0;\n    height: 100%;\n}\n\n.productPrice {\n    font-weight: bold;\n}\n\n.productName {\n    font-weight: 500;\n    margin-top: 5px;\n    font-size: 1.2rem;\n}\n\n@media (max-width: 650px) {\n    .addButton {\n        right: 5px !important;\n    }\n\n    .quantityButtons {\n        right: 5px !important;\n    }\n\n    .container {\n        margin: 0 !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `large_product_card_container__PNciR`,
	"addButton": `large_product_card_addButton__TqIdE`,
	"quantityButtons": `large_product_card_quantityButtons__Xtm4X`,
	"quantityPlusMinus": `large_product_card_quantityPlusMinus__+PmDx`,
	"productImage": `large_product_card_productImage__U0iJQ`,
	"productInfo": `large_product_card_productInfo__YLKmj`,
	"productPrice": `large_product_card_productPrice__PWsMp`,
	"productName": `large_product_card_productName__jeZdA`
};
export default ___CSS_LOADER_EXPORT___;
